import RESTAdapter from '@ember-data/adapter/rest';
import { service } from '@ember/service';
import { ObjectId } from 'bson';
import { InvalidError } from '@ember-data/adapter/error';
import config from 'cpc-license-manager/config/environment';

export default class ApplicationAdapter extends RESTAdapter {
  host = config.servicePrefix;

  @service currentUser;
  @service session;

  get headers() {
    let headers = {
      'X-ws-session': this.currentUser.tabSession,
      'X-user-name': this.currentUser.user?.userName ?? '',
      accept: 'application/json',
    };

    headers = { ...this.session.formattedHeaders, ...headers };

    return headers;
  }

  shouldBackgroundReloadRecord() {
    return false;
  }

  shouldReloadAll() {
    return true;
  }

  generateIdForRecord() {
    return new ObjectId().toString();
  }

  handleResponse(status, headers, payload) {
    if (status === 401 && this.session.isAuthenticated) {
      this.session.invalidate();
      return;
    }

    if ((status === 400 || status === 422) && payload.error != null) {
      const error = payload.error;
      const invalidError = new InvalidError([error], error.message);
      invalidError.contextVariables = error.contextVariables;
      invalidError.isValidationError = error.isValidationError;
      return invalidError;
    }

    return super.handleResponse(...arguments);
  }

  // make sure native fetch is used
  _fetchRequest(options) {
    return fetch(options.url, options);
  }
}
